import type { Dispatch } from 'redux';
import { setOpenLocked } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/inline-create';
import type { SelectForColumnCellProps } from './types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (dispatch: Dispatch, ownProps: SelectForColumnCellProps) => ({
	lockInlineCreate: (isLocked: boolean) => {
		dispatch(setOpenLocked({ attribute: ownProps.attribute, isLocked }));
	},
});
